import * as React from 'react';

import { SegmentLabel } from '@acceligentllc/storybook';

import AddressField from 'af-components/SharedForms/WorkLocationAddress/AddressField';

import type { WorkLocationAddressFM } from '../../formModel';
import { formSectionClass, formSectionClassRow } from '../../helpers';

type OwnProps = {
	formName: string;
	isDisabled: boolean;
	workLocation: Nullable<WorkLocationAddressFM>;
	clearAddress: () => void;
};

type Props = OwnProps;

const WorkLocationSection: React.FC<Props> = ({ formName, isDisabled, workLocation, clearAddress }) => {
	return (
		<div className={formSectionClass}>
			<div className={formSectionClassRow}>
				<SegmentLabel
					label="Work Location"
					tooltip={`
						Location where work is being done — used to determine the time zone for payroll reports.
						If a Work Order has no work location set, the time zone is taken from this address;
						otherwise, the company's time zone is used
					`}
				/>
			</div>
			<AddressField
				backupPropName="workLocation.backup"
				cityPropName="workLocation.city"
				clearAddress={clearAddress}
				country={workLocation?.country}
				countryPropName="workLocation.country"
				disabled={isDisabled}
				disableMap={false}
				disableRemove={true}
				formName={formName}
				latitude={workLocation?.backup?.latitude ?? null}
				locationPropName={'workLocation.location'}
				longitude={workLocation?.backup?.longitude ?? null}
				neighborhoodPropName="workLocation.neighborhood"
				notesPropName="workLocation.notes"
				postalCodePropName="workLocation.postalCode"
				routePropName="workLocation.street"
				statePropName="workLocation.state"
				streetNumberPropName="workLocation.streetNumber"
			/>
		</div>
	);
};

export default React.memo(WorkLocationSection);
